import { useState } from 'react';

type UseDragDropResult = {
  isDragOver: boolean;
  dragHandlers: {
    onDragOver: (event: React.DragEvent<HTMLDivElement>) => void;
    onDragLeave: () => void;
    onDrop: (event: React.DragEvent<HTMLDivElement>) => void;
  };
};

export function useDocumentDrop(onFiles: (files: File[]) => void): UseDragDropResult {
  const [isDragOver, setIsDragOver] = useState(false);

  const onDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setIsDragOver(true);
  };

  const onDragLeave = () => {
    setIsDragOver(false);
  };

  const onDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setIsDragOver(false);
    const files = Array.from(event.dataTransfer.files);
    if (files.length > 0) {
      onFiles(files);
    }
  };

  return { isDragOver, dragHandlers: { onDragOver, onDragLeave, onDrop } };
}
